var _Path, _Path2, _Path3, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgBenchAndDumbbells(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#bench-and-dumbbells_svg__clip0_484_2456)",
    fill: props.fill
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M4.85 20.833a2.951 2.951 0 002.764-3.104 2.907 2.907 0 00-3.08-2.753 2.953 2.953 0 00-2.763 3.105 2.907 2.907 0 003.08 2.752z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M30.868 27.996l-2.163-7.03a4.11 4.11 0 00-1.317-1.97 4.076 4.076 0 00-2.076-.88l-13.228-1.153h-.006a.493.493 0 01-.415-.524l.335-5.226.838.06-.114 1.6a.611.611 0 00.566.652l1.606.114.044.001a.611.611 0 00.608-.568l.376-5.301a.611.611 0 00-.565-.652l-1.607-.114a.61.61 0 00-.652.565l-.126 1.784-.852-.061a1.443 1.443 0 00-2.875-.23l-.01-.03-.004.055-.747-.053.126-1.784a.605.605 0 00-.56-.646l-1.601-.113a.605.605 0 00-.646.56l-.377 5.302a.605.605 0 00.56.646l1.602.114a.605.605 0 00.646-.56l.114-1.6.719.051-.842 9.85c0 .512.415.926.926.926 0 0 13.915.272 15.21.314.43.014.812.27.99.66l2.757 6.09a1.44 1.44 0 001.803.955 1.442 1.442 0 00.956-1.804z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M23.716 23.225H3.367a.962.962 0 100 1.924h5.536l-4.467 4.467a.962.962 0 101.36 1.36l5.828-5.827h3.818l5.828 5.828a.957.957 0 001.36 0 .962.962 0 000-1.36l-4.467-4.468h5.553a.962.962 0 100-1.924z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "bench-and-dumbbells_svg__clip0_484_2456"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}

export default SvgBenchAndDumbbells;